export default "__VITE_ASSET__B6UXnkZo__"